import { render, staticRenderFns } from "./RouterViewWrap.vue?vue&type=template&id=0f581a83&"
import script from "./RouterViewWrap.vue?vue&type=script&lang=js&"
export * from "./RouterViewWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports